import { render, staticRenderFns } from "./oncoPheno.vue?vue&type=template&id=055a334a&"
import script from "./oncoPheno.vue?vue&type=script&lang=js&"
export * from "./oncoPheno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports